<script lang="ts">
  import type { Filter } from "./filter";

  let { value, onchange }: { value: Filter; onchange: (f: Filter) => void } = $props();

  const CHIPS: { key: Filter; label: string }[] = [
    { key: "all", label: "All" },
    { key: "vault", label: "Vault" },
    { key: "personal", label: "Personal" },
    { key: "work", label: "Work" },
  ];

  function pick(k: Filter) {
    if (k !== value) onchange(k);
  }
</script>

<div class="segmented" role="tablist">
  {#each CHIPS as c (c.key)}
    <button
      type="button"
      class="segment"
      class:active={value === c.key}
      role="tab"
      aria-selected={value === c.key}
      onclick={() => pick(c.key)}
    >
      {c.label}
    </button>
  {/each}
</div>

<style>
  /* iOS segmented control — pill background with sliding active segment */
  .segmented {
    display: flex;
    background: var(--bg-elev);
    border-radius: 9px;
    padding: 2px;
    margin: 4px 0 14px;
    gap: 0;
    position: relative;
  }
  .segment {
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 10px;
    border-radius: 7px;
    color: var(--fg);
    background: transparent;
    transition: background 0.18s, color 0.18s, transform 0.1s;
    min-height: 28px;
    letter-spacing: -0.005em;
  }
  .segment:active { transform: scale(0.97); }
  .segment.active {
    background: var(--bg-elev-2);
    color: var(--fg);
    box-shadow:
      0 3px 8px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.04),
      inset 0 0 0 0.5px rgba(255, 255, 255, 0.06);
    font-weight: 600;
  }
  .segment:not(.active) { color: var(--fg-dim); }
</style>
